// C4 · إضافة موظف (فردي) — per-screen i18n namespace (merged into the root
// messages by i18n.ts's require.context). Full ar/en parity for every key the
// employee-add.vue view binds.
module.exports = {
  ar: {
    'employee-add': {
      title: 'إضافة موظف',
      crumbNew: 'جديد',
      loading: 'جارٍ التحميل…',
      error: 'حدث خطأ أثناء تحميل بيانات النموذج',
      panelTitle: 'بيانات الموظف الجديد',
      defaultActive: 'نشط افتراضيًا',
      savedTitle: 'تم الحفظ',
      savedMsg: 'تمت إضافة الموظف {name} بنجاح.',
      submitErrorTitle: 'خطأ',
      submitErrorMsg: 'لم يتم الحفظ — راجع البيانات وحاول مرة أخرى.',
      selectPlaceholder: '— اختر —',
      f: {
        fullName: 'الاسم الكامل',
        nationalId: 'الرقم القومي (14 رقم)',
        birthDate: 'تاريخ الميلاد',
        gender: 'النوع',
        department: 'القسم / الوظيفة',
        policy: 'البوليصة',
        contractEntity: 'الفئة',
        phone: 'رقم الموبايل',
        email: 'البريد الإلكتروني',
        hireDate: 'تاريخ التعيين',
        cardNumber: 'رقم كارت التأمين',
        status: 'الحالة',
      },
      ph: {
        fullName: 'مثال: أحمد سمير محمود',
        nationalId: '29XXXXXXXXXXXX',
        phone: '010XXXXXXXX',
        email: 'name@vivo-eg.com',
        cardNumber: 'اكتب رقم الكارت حسب شركة التأمين',
      },
      cardHint: 'إدخال يدوي إلزامي — لكل شركة تأمين نظام ترقيم مختلف',
      tierHint: 'فئة الموظف من شجرة العقد — تحدّد السقف السنوي ونسبة التحمّل والشبكة',
      noTiersHint: 'لا توجد فئات في شجرة العقد بعد — سيُضاف الموظف بدون فئة إلى أن يضيف فريق Vivo الفئات',
      tiersLoadFailedHint: 'تعذّر تحميل الفئات — حاول مرة أخرى',
      gender: { male: 'ذكر', female: 'أنثى' },
      status: { active: 'نشط', suspended: 'موقوف', left: 'مغادر' },
      save: 'حفظ',
      saveAndAnother: 'حفظ وإضافة آخر',
      cancel: 'إلغاء',
      searchPlaceholder: 'بحث سريع',
      warnTitle: 'تنبيه',
      warnMsg: 'يجب أن يتكوّن الرقم القومي من 14 رقماً وألا يكون مكرراً لموظف آخر في نفس الشركة.',
      err: {
        required: 'هذا الحقل مطلوب',
        nid: 'يجب أن يتكوّن الرقم القومي من 14 رقماً',
        email: 'البريد الإلكتروني غير صحيح',
      },
      warn: {
        nidCentury: '⚠ الرقم القومي غير معتاد — تأكد من صحة أول رقم (يجب أن يكون 2 أو 3)',
        phoneFormat: '⚠ رقم الموبايل غير معتاد — المعتاد أن يبدأ بـ01 ويتكوّن من 11 رقماً',
      },
    },
  },
  en: {
    'employee-add': {
      title: 'Add Employee',
      crumbNew: 'New',
      loading: 'Loading…',
      error: 'Something went wrong loading the form data',
      panelTitle: 'New employee details',
      defaultActive: 'Active by default',
      savedTitle: 'Saved',
      savedMsg: 'Employee {name} was added successfully.',
      submitErrorTitle: 'Error',
      submitErrorMsg: 'Save failed — check the data and try again.',
      selectPlaceholder: '— Select —',
      f: {
        fullName: 'Full name',
        nationalId: 'National ID (14 digits)',
        birthDate: 'Date of birth',
        gender: 'Gender',
        department: 'Department / Role',
        policy: 'Policy',
        contractEntity: 'Tier',
        phone: 'Mobile number',
        email: 'Email',
        hireDate: 'Hire date',
        cardNumber: 'Insurance card number',
        status: 'Status',
      },
      ph: {
        fullName: 'e.g. Ahmed Samir Mahmoud',
        nationalId: '29XXXXXXXXXXXX',
        phone: '010XXXXXXXX',
        email: 'name@vivo-eg.com',
        cardNumber: 'Enter the card number per the insurer',
      },
      cardHint: 'Manual entry required — every insurer uses a different numbering system',
      tierHint: 'The employee tier from the contract tree — sets the annual cap, copay and network',
      noTiersHint: 'The contract tree has no tiers yet — the employee will be added without a tier until the Vivo team adds them',
      tiersLoadFailedHint: "Couldn't load the tiers — try again",
      gender: { male: 'Male', female: 'Female' },
      status: { active: 'Active', suspended: 'Suspended', left: 'Left' },
      save: 'Save',
      saveAndAnother: 'Save & add another',
      cancel: 'Cancel',
      searchPlaceholder: 'Quick search',
      warnTitle: 'Note',
      warnMsg: 'The national ID must be 14 digits and unique per employee within the same company.',
      err: {
        required: 'This field is required',
        nid: 'The national ID must be 14 digits',
        email: 'The email is not valid',
      },
      warn: {
        nidCentury: '⚠ Unusual national ID — check the first digit (should be 2 or 3)',
        phoneFormat: '⚠ Unusual mobile number — it should start with 01 and be 11 digits',
      },
    },
  },
};
